<template>
    <g>
        <path
            d="M1.5791 27.4027C2.45177 30.5693 5.31913 33.111 9.64094 33.111C13.7965 33.111 16.5808 30.5277 16.5808 26.486C16.5808 23.7777 14.877 21.7777 11.4694 20.5693C8.10337 19.2777 7.06447 18.486 7.06447 17.2777C7.06447 16.0693 8.06181 15.2777 9.3916 15.2777C10.8876 15.2777 12.0927 15.9443 12.9654 17.2777L15.6665 14.8193C14.3783 12.611 12.1758 11.4443 9.35004 11.4443C5.69313 11.4443 2.95044 13.9443 2.95044 17.1943C2.95044 20.3193 4.73735 22.0693 8.02026 23.2777C10.8876 24.4027 12.4252 25.2777 12.4252 26.736C12.4252 28.361 11.2616 29.2777 9.64094 29.2777C7.52159 29.2777 5.98402 28.0277 5.11135 25.5277L1.5791 27.4027Z"
            fill="black"
        />
        <path
            d="M18.9731 32.7777H23.3781V24.611C23.3781 18.6527 25.4559 15.2777 28.4063 15.2777C30.401 15.2777 31.3568 16.361 31.3568 18.736V32.7777H35.7201V24.2777C35.7201 18.486 37.9226 15.2777 40.7484 15.2777C42.7431 15.2777 43.6989 16.361 43.6989 18.736V32.7777H48.0622V18.0277C48.0622 13.8193 45.9013 11.4443 41.912 11.4443C39.294 11.4443 36.8837 13.1527 35.3877 15.861C34.5566 12.9027 32.4372 11.4443 29.5699 11.4443C27.035 11.4443 24.9572 12.7777 23.3781 15.4443V11.7777H18.9731V32.7777Z"
            fill="black"
        />
        <path
            d="M50.2283 26.736C50.2283 30.861 52.9295 33.111 56.6279 33.111C59.4122 33.111 61.5731 32.0693 63.1106 29.9443L63.6924 32.7777H67.2247V19.8193C67.2247 14.361 64.0664 11.4443 58.872 11.4443C54.841 11.4443 51.6828 13.7777 51.0179 17.236L54.841 18.111C55.4644 16.236 56.8357 15.2777 58.872 15.2777C61.2406 15.2777 62.8613 16.4443 62.8613 18.9443V19.861H59.2044C53.6775 19.861 50.2283 22.4443 50.2283 26.736ZM62.8613 23.986C62.8613 27.4027 60.2017 29.2777 57.6668 29.2777C55.963 29.2777 54.7995 28.236 54.7995 26.6943C54.7995 24.5277 56.3786 23.4443 59.3706 23.4443H62.8613V23.986Z"
            fill="black"
        />
        <path
            d="M70.5771 32.7777H74.982V25.111C74.982 18.5693 77.3507 15.4027 80.6336 15.4027C81.5478 15.4027 82.3374 15.611 83.0438 16.0277L83.8749 11.9443C82.8776 11.611 81.9634 11.4443 81.1738 11.4443C78.6389 11.4443 76.3533 12.7777 74.982 15.2777V11.7777H70.5771V32.7777Z"
            fill="black"
        />
        <path
            d="M87.4289 25.7777C87.4289 30.6527 90.047 33.111 94.4103 33.111C95.6985 33.111 96.8621 32.861 97.8594 32.361L96.8205 28.736C96.1972 29.111 95.4492 29.2777 94.6181 29.2777C92.7896 29.2777 91.8338 28.3193 91.8338 25.861V15.611H97.4023V11.7777H91.8338V3.27768L87.4289 6.06934V11.7777H84.0629V15.611H87.4289V25.7777Z"
            fill="black"
        />
        <path
            d="M101.008 22.2779C101.008 28.2779 104.956 33.1112 111.397 33.1112C117.797 33.1112 121.786 28.2779 121.786 22.2779C121.786 16.2779 117.797 11.4445 111.397 11.4445C104.956 11.4445 101.008 16.2779 101.008 22.2779ZM117.174 22.2779C117.174 24.2362 116.675 25.8612 115.636 27.2362C114.597 28.6112 113.184 29.2779 111.397 29.2779C109.61 29.2779 108.156 28.6112 107.117 27.2362C106.078 25.8612 105.579 24.2362 105.579 22.2779C105.579 20.3195 106.078 18.6946 107.117 17.3196C108.156 15.9446 109.61 15.2779 111.397 15.2779C113.184 15.2779 114.597 15.9446 115.636 17.3196C116.675 18.6946 117.174 20.3195 117.174 22.2779Z"
            fill="url(#paint0_linear_23441:65223)"
        />
        <path
            d="M128.313 32.7779H132.302L136.167 18.1112L139.99 32.7779H143.979L150.545 11.7779H146.099L142.026 27.0696L138.203 11.7779H134.089L130.266 27.0696L126.193 11.7779H121.747L128.313 32.7779Z"
            fill="url(#paint1_linear_23441:65223)"
        />
        <path
            d="M151.95 32.7779H156.355V24.1529C156.355 18.6112 158.806 15.2779 161.715 15.2779C163.876 15.2779 165.123 16.5695 165.123 19.1112V32.7779H169.486V17.9446C169.486 13.7779 166.91 11.4445 163.045 11.4445C160.344 11.4445 157.892 12.9862 156.355 15.4446V11.7779H151.95V32.7779Z"
            fill="url(#paint2_linear_23441:65223)"
        />
        <path
            d="M191.652 21.6112C191.652 16.4445 188.328 11.4445 182.053 11.4445C175.612 11.4445 172.246 16.6945 172.246 22.2779C172.246 27.8612 175.612 33.1112 182.053 33.1112C186.666 33.1112 189.533 31.1112 191.361 27.0696L187.746 25.6529C186.375 28.1529 184.796 29.2779 182.261 29.2779C179.144 29.2779 177.108 27.1112 176.734 23.4446H191.652V21.6112ZM176.942 19.8612C177.606 16.9029 179.56 15.2779 182.053 15.2779C185.003 15.2779 186.666 17.1529 187.164 19.8612H176.942Z"
            fill="url(#paint3_linear_23441:65223)"
        />
        <path
            d="M194.382 32.7779H198.787V25.1112C198.787 18.5695 201.156 15.4029 204.439 15.4029C205.353 15.4029 206.142 15.6112 206.849 16.0279L207.68 11.9446C206.683 11.6112 205.768 11.4445 204.979 11.4445C202.444 11.4445 200.158 12.7779 198.787 15.2779V11.7779H194.382V32.7779Z"
            fill="url(#paint4_linear_23441:65223)"
        />
        <path
            d="M74.7683 52.7417C75.0172 53.3333 75.7932 53.8384 76.6716 53.8384C79.2484 53.8384 80.6832 51.8903 80.6832 49.3362C80.6832 47.4459 79.7316 46.3348 78.0771 46.3348C77.2133 46.3348 76.3642 46.71 75.8371 47.2872L75.9396 46.7821L76.5691 43.5065H75.3539L73.3335 53.723H74.578L74.6365 53.3766L74.7683 52.7417ZM79.4095 49.5238C79.4095 51.1688 78.4578 52.7706 76.7448 52.7706C75.7346 52.7706 75.1197 52.0924 75.1197 50.7792C75.1197 49.1053 76.2031 47.4026 77.7404 47.4026C78.8092 47.4026 79.4095 48.1385 79.4095 49.5238Z"
            fill="black"
        />
        <path
            d="M80.6633 56.6667H81.9224L87.6324 46.4502H86.2854L83.328 51.9336L82.4495 46.4502H81.1904L82.391 53.5642L80.6633 56.6667Z"
            fill="black"
        />
        <path
            d="M89.7711 51.8615C90.0786 52.9582 91.0888 53.8384 92.6114 53.8384C94.0755 53.8384 95.0565 52.9437 95.0565 51.544C95.0565 50.6061 94.4562 49.9134 93.2556 49.495C92.0697 49.0476 91.7037 48.7735 91.7037 48.355C91.7037 47.9365 92.0551 47.6623 92.5236 47.6623C93.0507 47.6623 93.4753 47.8932 93.7827 48.355L94.7344 47.5036C94.2805 46.7388 93.5045 46.3348 92.509 46.3348C91.2206 46.3348 90.2543 47.2006 90.2543 48.3261C90.2543 49.4084 90.8838 50.0144 92.0405 50.4329C93.0507 50.8225 93.5924 51.1256 93.5924 51.6306C93.5924 52.1934 93.1824 52.5108 92.6114 52.5108C91.8648 52.5108 91.323 52.0779 91.0156 51.2121L89.7711 51.8615Z"
            fill="black"
        />
        <path
            d="M95.8994 53.723H97.4513V50.8947C97.4513 48.8312 98.1833 47.6623 99.2228 47.6623C99.9256 47.6623 100.262 48.0375 100.262 48.86V53.723H101.8V50.7792C101.8 48.7735 102.576 47.6623 103.571 47.6623C104.274 47.6623 104.611 48.0375 104.611 48.86V53.723H106.148V48.6147C106.148 47.1573 105.387 46.3348 103.981 46.3348C103.059 46.3348 102.21 46.9264 101.683 47.8644C101.39 46.8398 100.643 46.3348 99.6328 46.3348C98.7397 46.3348 98.0077 46.7965 97.4513 47.7201V46.4502H95.8994V53.723Z"
            fill="black"
        />
        <path
            d="M106.911 51.6306C106.911 53.0592 107.863 53.8384 109.166 53.8384C110.147 53.8384 110.908 53.4776 111.45 52.7417L111.655 53.723H112.899V49.2352C112.899 47.3449 111.787 46.3348 109.956 46.3348C108.536 46.3348 107.424 47.1429 107.189 48.3406L108.536 48.6436C108.756 47.9942 109.239 47.6623 109.956 47.6623C110.791 47.6623 111.362 48.0664 111.362 48.9322V49.2496H110.074C108.126 49.2496 106.911 50.1443 106.911 51.6306ZM111.362 50.6782C111.362 51.8615 110.425 52.5108 109.532 52.5108C108.932 52.5108 108.522 52.1501 108.522 51.6162C108.522 50.8658 109.078 50.4906 110.132 50.4906H111.362V50.6782Z"
            fill="black"
        />
        <path
            d="M114.08 53.723H115.632V51.0678C115.632 48.8023 116.467 47.7056 117.623 47.7056C117.946 47.7056 118.224 47.7778 118.473 47.9221L118.765 46.5079C118.414 46.3925 118.092 46.3348 117.814 46.3348C116.921 46.3348 116.115 46.7965 115.632 47.6623V46.4502H114.08V53.723Z"
            fill="black"
        />
        <path
            d="M120.018 51.2987C120.018 52.987 120.94 53.8384 122.477 53.8384C122.931 53.8384 123.341 53.7518 123.692 53.5787L123.326 52.3232C123.107 52.4531 122.843 52.5108 122.55 52.5108C121.906 52.5108 121.57 52.1789 121.57 51.3276V47.7778H123.531V46.4502H121.57V43.5065L120.018 44.4733V46.4502H118.832V47.7778H120.018V51.2987Z"
            fill="black"
        />
        <path d="M124.155 53.723H125.707V43.5065H124.155V53.723Z" fill="black" />
        <path
            d="M127.083 53.723H128.635V46.4502H127.083V53.723ZM126.805 44.3579C126.805 44.9351 127.244 45.3824 127.844 45.3824C128.444 45.3824 128.898 44.9351 128.898 44.3579C128.898 43.7807 128.444 43.3333 127.844 43.3333C127.244 43.3333 126.805 43.7807 126.805 44.3579Z"
            fill="black"
        />
        <path
            d="M129.968 53.723H131.52V50.7359C131.52 48.8167 132.384 47.6623 133.409 47.6623C134.17 47.6623 134.609 48.1097 134.609 48.9899V53.723H136.147V48.5859C136.147 47.1429 135.239 46.3348 133.877 46.3348C132.926 46.3348 132.062 46.8687 131.52 47.7201V46.4502H129.968V53.723Z"
            fill="black"
        />
        <path
            d="M137.529 53.723H139.081V50.1732L141.906 53.723H143.81L140.574 49.798L143.59 46.4502H141.687L139.081 49.4084V43.5065H137.529V53.723Z"
            fill="black"
        />
        <defs>
            <linearGradient
                id="paint0_linear_23441:65223"
                x1="99.18"
                y1="20.5556"
                x2="208.333"
                y2="20.5556"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2B6AF0" />
                <stop offset="1" stop-color="#032A7C" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_23441:65223"
                x1="99.18"
                y1="20.5556"
                x2="208.333"
                y2="20.5556"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2B6AF0" />
                <stop offset="1" stop-color="#032A7C" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_23441:65223"
                x1="99.18"
                y1="20.5556"
                x2="208.333"
                y2="20.5556"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2B6AF0" />
                <stop offset="1" stop-color="#032A7C" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_23441:65223"
                x1="99.18"
                y1="20.5556"
                x2="208.333"
                y2="20.5556"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2B6AF0" />
                <stop offset="1" stop-color="#032A7C" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_23441:65223"
                x1="99.18"
                y1="20.5556"
                x2="208.333"
                y2="20.5556"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2B6AF0" />
                <stop offset="1" stop-color="#032A7C" />
            </linearGradient>
        </defs>
    </g>
</template>
<script>
export default {
    name: "SmartlinkLogo",
};
</script>
